module.exports = __webpack_public_path__ + "static/img/14000029.759f9de3.png";